import { colors, staticColors } from './customer/default/colors';
import { DARK_MODE, LIGHT_MODE, DEFAULT_MODE } from './modes';
import { hexToARGB } from './utils';

export * from './modes';
export * from './customer/default/colors';
export * from './utils';
export * from './constants';

export const getColor = ({ name, mode = DEFAULT_MODE, alpha = 1.0 }) => {
  const result = colors[mode][name];
  if (alpha < 1.0) {
    return hexToARGB(staticColors[mode][name], alpha);
  }

  return result;
};

export const getDarkColor = (name, alpha = 1.0) => getColor({ name, alpha, mode: DARK_MODE });

export const getLightColor = (name, alpha = 1.0) => getColor({ name, alpha, mode: LIGHT_MODE });

export const makeThemeColor = (name, alpha = 1.0) => ({
  [DARK_MODE]: getDarkColor(name, alpha),
  [LIGHT_MODE]: getLightColor(name, alpha),
});
